<template>
  <div class="booth">
    <!-- 光地展位 -->
    <div class="first">
      <p>光地展位</p>
      <div class="content">
        <div class="row">
          <div class="left">
            <span class="name">展位号：</span
            ><span>{{ exhibitorsMsg.bothNum }}</span>
          </div>
          <div class="right">
            <span class="name">展馆：</span>
            <span>{{ exhibitorsMsg.Gallery }}</span>
          </div>
          <div class="last">
            <span class="name">展位面积</span>
            <span>{{ exhibitorsMsg.bothear }}</span>
          </div>
        </div>

        <div class="row">
          <div class="left">
            <span class="name">展台限高：</span
            ><span>{{ exhibitorsMsg.maxHeight }}</span>
          </div>
          <div class="right">
            <span class="name">展位类型：</span>
            <span>{{ exhibitorsMsg.type }}</span>
          </div>
          <div class="last">
            <span class="name">展位图：</span>
            <span
              ><a href="">{{ exhibitorsMsg.exhiPict.name }}</a></span
            >
          </div>
        </div>
        <div class="row">
          <div class="left">
            <span class="name">所属展区：</span>
            <span>{{ exhibitorsMsg.area}}</span>
          </div>
        </div>
      </div>
    </div>
    <!--12m 标准展位  -->
    <div class="first">
      <p>12m²标准展位</p>
      <div class="content">
        <div class="row">
          <div class="left">
            <span class="name">展位号：</span
            ><span>{{ exhibitorsMsg.bothNum }}</span>
          </div>
          <div class="right">
            <span class="name">展馆：</span>
            <span>{{ exhibitorsMsg.Gallery }}</span>
          </div>
          <div class="last">
            <span class="name">展位面积</span>
            <span>{{ exhibitorsMsg.bothear }}</span>
          </div>
        </div>

        <div class="row">
          <div class="left">
            <span class="name">展台限高：</span
            ><span>{{ exhibitorsMsg.maxHeight }}</span>
          </div>
          <div class="right">
            <span class="name">展位类型：</span>
            <span>{{ exhibitorsMsg.type }}</span>
          </div>
          <div class="last">
            <span class="name">展位图：</span>
            <span
              ><a href="">{{ twelve.exhiPict.name }}</a></span
            >
          </div>
        </div>
        <div class="row">
          <div class="left">
            <span class="name">所属展区：</span>
            <span>{{ twelve.area }}</span>
          </div>
        </div>
        <div class="row">
          <div class="left special">
            <span class="name">展台效果图：</span>
            <div class="picture">
              <img :src="twelve.exhi_pic" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 9m的展位 -->
    <div class="first">
      <p>9m²标准展位</p>
      <div class="content">
        <div class="row">
          <div class="left">
            <span class="name">展位号：</span
            ><span>{{ exhibitorsMsg.bothNum }}</span>
          </div>
          <div class="right">
            <span class="name">展馆：</span>
            <span>{{ exhibitorsMsg.Gallery }}</span>
          </div>
          <div class="last">
            <span class="name">展位面积</span>
            <span>{{ exhibitorsMsg.bothear }}</span>
          </div>
        </div>

        <div class="row">
          <div class="left">
            <span class="name">展台限高：</span
            ><span>{{ exhibitorsMsg.maxHeight }}</span>
          </div>
          <div class="right">
            <span class="name">展位类型：</span>
            <span>{{ exhibitorsMsg.type }}</span>
          </div>
          <div class="last">
            <span class="name">展位图：</span>
            <span
              ><a href="">{{ twelve.exhiPict.name }}</a></span
            >
          </div>
        </div>
        <div class="row">
          <div class="left">
            <span class="name">所属展区：</span>
            <span>{{ twelve.area }}</span>
          </div>
        </div>
        <div class="row">
          <div class="left special">
            <span class="name">展台效果图：</span>
            <div class="picture">
              <img :src="twelve.exhi_pic" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      exhibitorsMsg: {
        bothNum: "W00001",
        Gallery: "W1馆",
        bothear: "24㎡",
        maxHeight: "5米",
        type: "单面开口",
        exhiPict: {
          name: "光地展位展位图.pdf",
          url: "",
        },
        area: "未分类",
      },
      //12m 标准展位
      twelve: {
        bothNum: "E0001",
        Gallery: "e1馆",
        bothear: "12㎡",
        maxHeight: "3.5米",
        type: "双面开口",
        exhiPict: {
          name: "12m²标准展位图.pdf",
          url: "",
        },
        area: "未分类",
        exhi_pic: require("@/static/tupian.png"),
      },
    };
  },

  components: {},

  computed: {},

  methods: {},
};
</script>
<style lang='scss' scoped>
.booth {
//   border: 1px solid red;
  .first {
    p {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 22px;
      padding-bottom: 9px;
      border-bottom: 1px solid #e9e9e9;
    }
    .content {
      // padding: 26px 130px 0px 130px;
      margin: 26px 130px 0px 130px;
      .row {
        display: flex;
        padding-bottom: 26px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        .left {
          width: 220px;
          display: flex;
          // align-items: center;
          .name {
            width: 72px !important;
            text-align: right;
          }
          .picture {
            width: 227px;
            height: 175px;
            // border: 1px solid red;
            img{
                width: 100%;
                height: 100%;
            }
          }
         
        }
        .special {
          width: 303px;
        }
        .right {
          display: flex;
          width: 250px;
          align-items: center;
          .name {
            display: block;
            width: 61px;
            text-align: right;
          }
        }
      }

      .dajian {
        border: 1px solid red;
        width: 80px !important;
      }
    }
  }
}
</style>